import { Component, OnInit, ViewChild } from '@angular/core';
import { SolicitacaoCompra, SolicitacaoCompraItem, defaultSolicitacaoCompra, defaultSolicitacaoCompraItem } from '../interface/solicitacao-compra';
import { ActivatedRoute, Router } from '@angular/router';
import { SolicitacaoCompraService } from '../service/solicitacao-compra.service';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoLookupComponent, PoModalComponent, PoNotificationService, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorCurto } from 'src/app/interface/fornecedor';
import { AuthService } from 'src/app/service/auth.service';
import { UsuarioBase } from 'src/app/interface/usuario';
import { NgForm } from '@angular/forms';
import { UtilService } from 'src/app/service/util';
import { defaultFiltroProdutoLista, FiltroProdutoLista, Produto } from 'src/app/interface/produto';
import { CentroCustoLookupService } from 'src/app/service/centro-custo-lookup-service';
import { ArmazemLookupService } from 'src/app/service/armazem-lookup-service';
import { ContaContabilLookupService } from 'src/app/service/conta-contabil-lookup-service';
import { ProdutoService } from 'src/app/service/produto-service';
import { environment } from 'src/environments/environment';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';
import { CentroCusto } from 'src/app/interface/centro-custo';

@Component({
  selector: 'app-solicitacao-compra-crud',
  templateUrl: './solicitacao-compra-crud.component.html',
  styleUrl: './solicitacao-compra-crud.component.css'
})
export class SolicitacaoCompraCrudComponent implements OnInit {

  solicitacaoCompra: SolicitacaoCompra = defaultSolicitacaoCompra();
  solicitacaoCompraItem: SolicitacaoCompraItem = defaultSolicitacaoCompraItem();
  solicitacaoCompraItemOriginal: SolicitacaoCompraItem = defaultSolicitacaoCompraItem();

  bloqueiaEdicao: boolean = false;
  fornecedorCodigoLoja: string = '';

  usuarioColumnsFilters:    Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();
  centroCustoColumnsFilters: Array<PoLookupColumn> = this.centroCustoLookupService.getColumnsFilter();
  contaContabilColumnsFilters: Array<PoLookupColumn> = this.contaContabilLookupService.getColumnsFilter();
  produtoColumnsFilters: Array<PoLookupColumn> = this.produtoLookupService.getColumnsFilter();
  armazemColumnsFilters: Array<PoLookupColumn> = this.armazemLookupService.getColumnsFilter();

  produtoItems: Array<Produto> = []
  filterZC1 = {CZC1CODZC0: '', combobox: 'S'};
  filterZC2 = {CZC2CODZC1: '', combobox: 'S'};
  filterPDMCombo = {CPDM: '', combobox: 'S'};
  produtosShowMoreDisable: boolean = true;
  filtroProdutoLista: FiltroProdutoLista = defaultFiltroProdutoLista();

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  urlApiProtheus: string = environment.urlApiProtheus;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Solicitação de Compra'},
    ],
  };

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private authService: AuthService,
    private utilService: UtilService,
    private solicitacaoCompraServices: SolicitacaoCompraService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
    public produtoService: ProdutoService,
    public centroCustoLookupService: CentroCustoLookupService,
    public contaContabilLookupService: ContaContabilLookupService,
    public armazemLookupService: ArmazemLookupService,
    public produtoLookupService: ProdutoLookupService,
  ){}

  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;
  @ViewChild('formItem'     , { static: true }) formItem!: NgForm;
  @ViewChild('modalItem'    , { static: true }) modalItem!: PoModalComponent;
  @ViewChild( 'modalProduto' , { static: true }) modalProduto!: PoModalComponent;

  async ngOnInit(){

    this.activateRoute.params.subscribe(async (params) => {
      if ('CC1NUM' in params) {
        this.loadDados(params['CC1NUM'],params['CACTION']);
      } else {
        this.solicitacaoCompra.DC1EMISSAO = new Date();
        this.solicitacaoCompra.CC1USER = (await this.authService.getUsuarioSessao()).CUSRID
      }
    })

  }

  async loadDados(CC1NUM: string, CACTION: string){

    this.solicitacaoCompraServices.getSolicitacaoCompra(CC1NUM, {CSHOEDESCRICAO: 'S'}).subscribe({
      next: async (solicitacao) => {

        this.solicitacaoCompra = solicitacao;

        if (CACTION === 'copy'){
          this.solicitacaoCompra.DC1EMISSAO = new Date();
          this.solicitacaoCompra.CC1USER = (await this.authService.getUsuarioSessao()).CUSRID
          this.solicitacaoCompra.CC1NUM = '';

          this.solicitacaoCompra.items.forEach( e=> {
            e.CC1RESIDUO = '';
            e.CSITUACAO = '';
            e.NC1QUJE = 0;
          })
        }

        this.fornecedorCodigoLoja = this.solicitacaoCompra.CC1FORNECE+this.solicitacaoCompra.CC1LOJA;

        if (this.solicitacaoCompra.items.filter(item=>item.NC1QUJE > 0).length > 0){
          this.bloqueiaEdicao = true;
        }
      }
    })

  }

  fornecedorSelecionado(fornecedor: FornecedorCurto){
    this.solicitacaoCompra.CC1FORNECE = fornecedor.CA2COD;
    this.solicitacaoCompra.CC1LOJA = fornecedor.CA2LOJA;
  }

  usuarioSelecionado(usuario: UsuarioBase){
    this.solicitacaoCompra.CC1SOLICIT = usuario.CUSRCODIGO;
  }

  adicionarItem():void {

    this.solicitacaoCompraItemOriginal = defaultSolicitacaoCompraItem();

    this.solicitacaoCompraItem = defaultSolicitacaoCompraItem();
    this.solicitacaoCompraItem.CC1ITEM = (this.solicitacaoCompra.items.length + 1).toString().padStart(4, '0');
    this.solicitacaoCompraItem.DC1DATPRF = new Date();
    this.solicitacaoCompraItem.DC1DATPRF.setDate(this.solicitacaoCompraItem.DC1DATPRF.getDate() + 30);
    this.modalItem.open();

  }

  editarItem(row: SolicitacaoCompraItem):void {

    this.solicitacaoCompraItem = {...row};
    this.solicitacaoCompraItemOriginal = {...row};
    this.atualizaProduto()

    this.modalItem.open();
  }

  editarItemDisabled(row: SolicitacaoCompraItem):boolean {
    return this.bloqueiaEdicao;
  }

  confirmarItem():void{

    if (this.formItem.valid){
      let pos = this.solicitacaoCompra.items.findIndex( e=> e.CC1ITEM === this.solicitacaoCompraItem.CC1ITEM );

      if (pos >= 0){
        this.solicitacaoCompra.items[pos] = this.solicitacaoCompraItem;
      } else {
        this.solicitacaoCompra.items.push(this.solicitacaoCompraItem);
      }

      this.solicitacaoCompra.items = [...this.solicitacaoCompra.items];

      this.modalItem.close();
    } else {
      this.utilService.showErrosFomulario(this.formItem,document);
    }
  }

  excluirItem(row: SolicitacaoCompraItem):void{
    this.poDialogService.confirm({
      title: 'Excluir Item',
      message: 'Deseja excluir o item?',
      confirm: () => {
        this.solicitacaoCompra.items = this.solicitacaoCompra.items.filter((item) => item.CC1ITEM !== row.CC1ITEM ).map((item, index) => {
          return {
            ...item,
            CC1ITEM: (index + 1).toString().padStart(4, '0')
          };
        });
      }
    })
  }

  copiarItem(row: SolicitacaoCompraItem):void{
    const produto = {...row, CC1ITEM: (this.solicitacaoCompra.items.length + 1).toString().padStart(4, '0')};

    this.solicitacaoCompraItem = produto;
    this.solicitacaoCompraItemOriginal = produto;

    this.modalItem.open();
  }

  produtoSelecionado(produto: Produto):void{

    if (this.solicitacaoCompraItem.CC1PRODUTO !== this.solicitacaoCompraItemOriginal.CC1PRODUTO || !this.solicitacaoCompraItemOriginal.CB1XCTACUS) {

      this.solicitacaoCompraItem.CB1DESC = produto.CB1DESC;
      this.solicitacaoCompraItem.CC1DESCRI = produto.CB1DESC;
      this.solicitacaoCompraItem.CC1UM = produto.CB1UM;
      this.solicitacaoCompraItem.CC1SEGUM = produto.CB1SEGUM;
      this.solicitacaoCompraItem.CC1LOCAL = produto.CB1LOCPAD;
      this.solicitacaoCompraItem.CB1XCTACUS = produto.CB1XCTACUS;
      this.solicitacaoCompraItem.CB1XCTADEC = produto.CB1XCTADEC;
      this.solicitacaoCompraItem.CB1XCTADEA = produto.CB1XCTADEA;
      this.solicitacaoCompraItem.CB1XCTADEF = produto.CB1XCTADEF;
      this.solicitacaoCompraItem.CB1CONTA = produto.CB1CONTA;
      this.atualizaContaContabil();

      this.solicitacaoCompraItemOriginal.CC1PRODUTO = this.solicitacaoCompraItem.CC1PRODUTO;
    }
  }

  ccSelecionado(cc: CentroCusto):void{
    this.atualizaProduto()
    setTimeout(() => {
     this.solicitacaoCompraItem.CCTTXCLASC = cc.CCTTXCLASC;
     this.atualizaContaContabil();
    }, 500);
  }

  atualizaContaContabil(): void {
    if (this.solicitacaoCompraItem.CC1PRODUTO != '' && this.solicitacaoCompraItem.CC1CC != '') {
      if (this.solicitacaoCompraItem.CCTTXCLASC == "1") {
        this.solicitacaoCompraItem.CC1CONTA = this.solicitacaoCompraItem.CB1XCTACUS;
      } else if (this.solicitacaoCompraItem.CCTTXCLASC == "2") {
        this.solicitacaoCompraItem.CC1CONTA = this.solicitacaoCompraItem.CB1XCTADEC;
      } else if (this.solicitacaoCompraItem.CCTTXCLASC == "3") {
        this.solicitacaoCompraItem.CC1CONTA = this.solicitacaoCompraItem.CB1XCTADEA;
      } else if (this.solicitacaoCompraItem.CCTTXCLASC == "4") {
        this.solicitacaoCompraItem.CC1CONTA = this.solicitacaoCompraItem.CB1XCTADEF;
      } else {
        this.solicitacaoCompraItem.CC1CONTA = this.solicitacaoCompraItem.CB1CONTA;
      }
    }
  }

  confirmarSolicitacao():void{
    if (this.formPrincipal.valid){
      if (this.solicitacaoCompra.items.length > 0){
        this.poDialogService.confirm({
          title: 'Gravar Solicitação de Compra',
          message: 'Deseja gravar a solicitação de compra?',
          confirm: () => {
            this.solicitacaoCompraServices.postSolicitacaoCompra(this.solicitacaoCompra).subscribe({
              next: (ret) => {
                this.goLista()
              }
            })
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Nenhum item foi informado. Informe ao menos um produto para ser comprado.',
          duration: 5000,
        })
      }
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }
  }


  public readonly tabelaItensColunas: Array<PoTableColumn> = [
    {property: 'CC1ITEM'   , label: 'Item'        , width: '08%', visible: true},
    {property: 'CC1PRODUTO', label: 'Produto'     , width: '10%', visible: true},
    {property: 'CC1DESCRI' , label: 'Descrição'   , width: '25%', visible: true},
    {property: 'CC1OBS'    , label: 'Observação'  , width: '25%', visible: true},
    {property: 'DC1DATPRF' , label: 'Necessidade' , width: '10%', visible: true , type: 'date'},
    {property: 'CC1UM'     , label: 'UM'          , width: '07%', visible: true},
    {property: 'NC1QUANT'  , label: 'Quantidade'  , width: '07%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'CC1CC'     , label: 'Centro Custo', width: '10%', visible: true},
    {property: 'CC1CONTA'  , label: 'Cta Ctb'     , width: '10%', visible: true},


  ]

  public readonly tabelaItensActions: Array<PoTableAction> = [
    {label: 'Editar' , action: this.editarItem.bind(this),  icon: 'po-icon-edit'  , disabled:  this.editarItemDisabled.bind(this)},
    {label: 'Excluir', action: this.excluirItem.bind(this), icon: 'po-icon-delete', disabled:  this.editarItemDisabled.bind(this)},
    {label: 'Copiar', action: this.copiarItem.bind(this)  , icon: 'po-icon-copy' , disabled:  this.editarItemDisabled.bind(this)},
  ]

  public readonly produtoColunas: Array<PoTableColumn> = [
    { property: 'CB1COD',     visible: true,  label: 'Código'           },
    { property: 'CB1DESC',    visible: true,  label: 'Descrição'        },
    { property: 'CB1XDESCL',  visible: true,  label: 'Descrição Longa'  },
    { property: 'CB1POSIPI',  visible: true,  label: 'NCM'              },
  ]



  goLista(): void {
    this.router.navigateByUrl('compras/solicitacao-compra/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  atualizaProduto(): void {
    this.produtoService.getProduto(this.solicitacaoCompraItem.CC1PRODUTO).subscribe({
      next: (item) => {
        this.produtoSelecionado(item);
      }
      ,error: () => {
        this.solicitacaoCompraItem.CC1PRODUTO = "";
      }
    });
  }

  produtoModalOpen(): void{
    this.modalProduto.open();
  }

  buscarProduto(zerarPaginacao: boolean): void {
    if (zerarPaginacao){
      this.filtroProdutoLista.page = 1;
      this.produtoItems = [];
    } else {
      this.filtroProdutoLista.page++;
    }
    this.produtoService.getProdutoLista(this.filtroProdutoLista).subscribe({
      next: (lista) =>{
        this.produtosShowMoreDisable = !lista.hasNext;
        this.produtoItems = this.produtoItems.concat(lista.items);
      }
    });
  }

  confirmarSelecaoProduto(): void {
    this.produtoItems.map((item) => {
      if (item.$selected) {
        this.solicitacaoCompraItem.CC1PRODUTO = item.CB1COD;
        this.produtoSelecionado(item);
      }
    })
    this.modalProduto.close();
  }

  onChangeNvl1() {
    this.filterZC1 = { CZC1CODZC0: this.filtroProdutoLista.CGRPNVL1, combobox: 'S' };
    this.filtroProdutoLista.CGRPNVL2 = '';
    this.filtroProdutoLista.CB1XPDM = '';
  }

  onChangeNvl2() {
    this.filterZC2 = { CZC2CODZC1: this.filtroProdutoLista.CGRPNVL2, combobox: 'S' };
    this.filtroProdutoLista.CB1XPDM = '';
  }

  onChangePDM() {
    this.filterPDMCombo = { CPDM: this.filtroProdutoLista.CB1XPDM, combobox: 'S' };
    this.filtroProdutoLista.CB1POSIPI = '';
  }
}
